import Swiper from "swiper/bundle"
import "swiper/css/bundle"

jQuery(initSlider)

function initSlider() {
  initTechServicesSliders()
  initCredentialsSliders()
}

// Duplico le slide se sono meno di minSlides per avere autoplay sempre continuo
function ensureMinSlides(selector, minSlides) {
  const $swiper = jQuery(selector)
  const $wrapper = $swiper.find(".swiper-wrapper")
  const $slides = $wrapper.children(".swiper-slide")

  if ($slides.length === 0) return
  if ($slides.length >= minSlides) return

  const cloneTimes = Math.ceil(minSlides / $slides.length) - 1

  for (let i = 0; i < cloneTimes; i++) {
    $slides.clone(true).appendTo($wrapper)
  }
}

function initTechServicesSliders() {
  // Swiper Technical services top
  if (jQuery(".swiper-tech-1").length) {
    ensureMinSlides(".swiper-tech-1", 6)

    new Swiper(".swiper-tech-1", {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 400,
      observer: true,
      observeParents: true,
      allowTouchMove: false,
      simulateTouch: false,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      speed: 12000,
      direction: "horizontal",
      on: {
        imagesReady(swiper) {
          swiper.autoplay.start()
        },
      },
    })
  }

  // Swiper Technical services bottom
  if (jQuery(".swiper-tech-2").length) {
    ensureMinSlides(".swiper-tech-2", 6)

    new Swiper(".swiper-tech-2", {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 400,
      speed: 10000,
      observer: true,
      observeParents: true,
      allowTouchMove: false,
      simulateTouch: false,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      direction: "horizontal",
      on: {
        imagesReady(swiper) {
          swiper.autoplay.start()
        },
      },
    })
  }
}

function initCredentialsSliders() {
  // Swiper Credentials
  if (jQuery(".swiper-credentials").length) {
    ensureMinSlides(".swiper-credentials", 8)

    new Swiper(".swiper-credentials", {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 140,
      speed: 12000,
      observer: true,
      observeParents: true,
      allowTouchMove: false,
      simulateTouch: false,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      direction: "horizontal",
      on: {
        imagesReady(swiper) {
          swiper.autoplay.start()
        },
      },
    })
  }
}
